module.exports = require("./fr-SN");